module.exports = __webpack_public_path__ + "img/2.05.733ed224.jpg";